import { toast } from 'react-toastify'

import { VscChromeClose } from 'react-icons/vsc'
import { useEffect, useRef, useState } from 'react';
import { types_subject } from '../api/api';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { MdContentCopy } from 'react-icons/md';
import useAuth from '../hooks/useAuth';
import PriceRangeButton from './types/PriceRangeButton';
import { getDownloadLinkTitle } from '../services/help';
import { SUBJECT_TYPES, getOnlinePlaybackLinks } from './dashboard/ADMIN/components/videoHelper';
import { IoMdArrowDropdown } from 'react-icons/io';


const findType = (type_id, types) => {
  if (types.length > 0 && type_id !== 0) {
    for (let index = 0; index < types.length; index++) {
      if (types[index].id === type_id && types[index].title) return `(${types[index].title})`
    }
  } else {
    return ''
  }
}

const escapeHtmlAttr = (value) =>
  String(value)
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')

const buildPlayerCopyText = (url, kind) => {
  const src = escapeHtmlAttr(url)

  if (kind === 'iframe') {
    return `<iframe src="${src}" width="640" height="360" frameborder="0" allow="fullscreen" allowfullscreen></iframe>`
  }

  if (kind === 'embed') {
    return `<embed src="${src}" width="640" height="360">`
  }

  return url
}

const copyToClipboard = (value) => {
  navigator.clipboard.writeText(value)
  toast.success('کپی شد', { autoClose: 700, theme: 'dark' })
}

const PlayerCopyMenu = ({ link }) => {
  const [open, setOpen] = useState(false)
  const menuRef = useRef(null)

  useEffect(() => {
    if (!open) return undefined

    const close = (event) => {
      if (!menuRef.current?.contains(event.target)) setOpen(false)
    }

    document.addEventListener('mousedown', close)
    return () => document.removeEventListener('mousedown', close)
  }, [open])

  const options = [
    { id: 'link', label: 'کپی لینک', value: buildPlayerCopyText(link, 'link') },
    { id: 'iframe', label: 'کپی iFrame', value: buildPlayerCopyText(link, 'iframe') },
    { id: 'embed', label: 'کپی embed', value: buildPlayerCopyText(link, 'embed') },
  ]

  return (
    <div className={`copyMenu${open ? ' open' : ''}`} ref={menuRef}>
      <button type='button' onClick={() => setOpen((current) => !current)}>
        کپی <IoMdArrowDropdown />
      </button>
      {open ? (
        <ul>
          {options.map((option) => (
            <li key={option.id}>
              <button
                type='button'
                onClick={() => {
                  copyToClipboard(option.value)
                  setOpen(false)
                }}
              >
                {option.label}
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  )
}

const PlayerLinkBox = ({ title, link, sizeLabel, forceShow = false, playerMenu = false }) => {
  if (!link && !forceShow) return null

  return (
    <div className='boxdlLinks'>
      <div className='topDLBox'>
        <span>{title}</span>
        {sizeLabel ? <small>{sizeLabel}</small> : <small />}
      </div>
      <div className='CopyLinkDL'>
        {playerMenu ? (
          <PlayerCopyMenu link={link} />
        ) : (
          <button
            disabled={!link}
            onClick={() => {
              if (!link) return
              copyToClipboard(link)
            }}
          >
            کپی لینک
          </button>
        )}
        <input type='text' value={link || ''} readOnly placeholder={forceShow && !link ? 'به‌زودی...' : undefined} />
      </div>
    </div>
  )
}


export default function FixPanel({ show, onClose, data, title, post_id, subjectType, videos = [], video = null }) {

  const location = useLocation();
  const [purchased, setPurchased] = useState(false)
  const isVideo = subjectType === SUBJECT_TYPES.VIDEO
  const playerLinks = isVideo ? getOnlinePlaybackLinks(videos, video) : []

  useEffect(() => {
    if (location.pathname.startsWith("/purchased")) {
      setPurchased(true)
    } else {
      setPurchased(false)
    }
  }, [location]);

  const [loading, setLoading] = useState(false)
  const [paidLinks, setPaidLinks] = useState([])
  const [freeLinks, setFreeLinks] = useState([])
  const [freePaidTabs, setFreePaidTabs] = useState('free')
  const [freeTypes, setFreeTypes] = useState([])
  const [paidTypes, setPaidTypes] = useState([])
  const [filterLinks, setFilterLinks] = useState(null)



  // const navigate = useNavigate()
  const { auth } = useAuth()
  const isBUYER = auth?.role?.length === 1 && auth.role[0] === 'BUYER'

  useEffect(() => {

    const paid_links = data.filter(f => f?.branchLinks[0]?.price > 0)
    const free_links = data.filter(f => f?.branchLinks[0]?.price === 0)

    setFreePaidTabs(free_links.length > 0 ? 'free' : 'paid')
    setFreeLinks(free_links)
    setPaidLinks(paid_links)

    //get types
    const getTypes = async () => {
      try {
        setLoading(true)
        const res = await axios.get(types_subject())
        const data = res.data

        const free_types = free_links.map(f => f.branchLinks[0].downloadLinks[0].type)
        const paid_types = paid_links.map(f => f.branchLinks[0].downloadLinks[0].type)
        setFreeTypes(data.filter(f => free_types.includes(f.id)))
        setPaidTypes(data.filter(f => paid_types.includes(f.id)))
      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false)
      }
    }
    getTypes()

  }, [data])


  useEffect(() => {
    setFilterLinks(null)
  }, [data])

  const handleChangeVersion = (e) => {
    setFilterLinks(parseInt(e.target.value))
  }

  const filteredLinks = (data) => {
    const items = filterLinks !== null ? data.filter(f => f.id === filterLinks) : [data[0]]
    const linkCounter = items[0]?.branchLinks[0]?.downloadLinks[0].links.length

    return items[0]?.branchLinks[0]?.downloadLinks[0].links.map((item, i) => (<div key={i}>
      <div className='boxdlLinks'>
        <div className='topDLBox'>
          <span>{getDownloadLinkTitle(item, i)}</span>
          <small>{item.size} MB</small>
        </div>
        <div className='CopyLinkDL'>
          <button
            onClick={() => {
              navigator.clipboard.writeText(item.link)
              toast.success('کپی شد', { autoClose: 700, theme: 'dark' })
            }}
          >
            کپی لینک
          </button>
          <input type='text' value={item.link} readOnly />
        </div>
      </div>

      {i === (linkCounter - 1) && isVideo
        ? playerLinks.map((playerLink) => (
          <PlayerLinkBox
            key={playerLink.id ?? playerLink.playbackUrl}
            title={`پخش آنلاین (${playerLink.title})`}
            link={playerLink.playbackUrl}
            playerMenu
          />
        ))
        : null}

      {/* تمام پارت ها یکجا */}
      {i === (linkCounter - 1) && linkCounter > 1 ? (
        <div className='boxdlLinks'>
          <div className='CopyLinkDL'>

            <button style={{ width: '100%', borderRadius: '.25rem', marginLeft: '5px' }}
              onClick={() => window.open(`https://traffic.sekaans.com/download/${post_id}/${auth.userMediaName ? auth.userMediaName : auth.userId}/${items[0].id}`, '_blank')}
            >تمام پارت ها یکجا</button>

            <button
              style={{ borderRadius: '.25rem', background: '#9f9f9f', borderColor: '#9f9f9f' }}
              onClick={() => {
                // navigator.clipboard.writeText(`https://${window.location.host}/download/${post_id}/${auth.userMediaName ? auth.userMediaName : auth.userId}/${items[0].id}`)
                navigator.clipboard.writeText(`https://traffic.sekaans.com/download/${post_id}/${auth.userMediaName ? auth.userMediaName : auth.userId}/${items[0].id}`)
                toast.success('کپی شد', { autoClose: 700, theme: 'dark' })
              }}>
              <MdContentCopy />
            </button>

          </div>
        </div>
      ) : ''}


    </div>))
  }



  return (
    <>
      <div className={`fixpanel ${show ? 'show' : ''}`}>
        <div className='panelside'>
          <div className='head_panel'>
            <span className='closePanel' onClick={onClose}>
              <VscChromeClose />
            </span>
            <span className='ellipsis'>{title}</span>
          </div>
          <div className='content_panel'>


            <div className='paid_free'>
              {!purchased && <button
                className={freePaidTabs === 'free' ? 'active' : ''}
                onClick={() => {
                  setFreePaidTabs('free')
                  setFilterLinks(null)
                }}
                disabled={freeLinks.length > 0 ? false : true}
              >
                رایگان
              </button>}

              <button
                className={freePaidTabs === 'paid' ? 'active' : ''}
                onClick={() => {
                  setFreePaidTabs('paid')
                  setFilterLinks(null)
                }}
                disabled={paidLinks.length > 0 ? false : true}
              >
                {purchased ? 'خریداری شده' : 'فروش'}
              </button>
            </div>




            {freePaidTabs === 'free' &&
              <div>

                <div className="versionLinks">
                  <span>نسخه :</span>
                  <select name="versions" id="versions" disabled={freeLinks.length > 1 ? false : true} onChange={handleChangeVersion}>
                    {freeLinks.map(s => (
                      <option value={s.id} key={s.id}>
                        {`${s.title} ${loading ? '...' : findType(s.branchLinks[0].downloadLinks[0].type, freeTypes)}`}
                      </option>
                    ))}
                  </select>
                </div>

                <hr style={{ opacity: .1 }} />
                {filteredLinks(freeLinks)}


              </div>
            }

            {freePaidTabs === 'paid' &&
              <div>
                <div className="versionLinks">
                  <span>نسخه :</span>
                  <select name="versions" id="versions" disabled={paidLinks.length > 1 ? false : true} onChange={handleChangeVersion}>
                    {paidLinks.map(s => (
                      <option value={s.id} key={s.id} price={s.branchLinks[0]?.price}>
                        {`${s.title} ${loading ? '...' : findType(s.branchLinks[0].downloadLinks[0].type, paidTypes)}`}
                      </option>
                    ))}
                  </select>
                </div>



                {/* نمایش کد فعالسازی برای کاربر خریدار */}
                {(paidLinks.length > 0 && purchased) &&
                  paidLinks.map((item) => (
                    item.haveActivationKey &&

                    item.activationCodes?.map((code, i) => (
                      <div className="versionLinks" key={i}>
                        <span style={{ width: 190 }}>کد فعالسازی :</span>
                        <input style={{ border: 0, borderRadius: 0, padding: 10, fontWeight: 300, direction: 'ltr' }} type="text" defaultValue={code} readOnly={true} />
                        <button
                          style={{ borderRadius: '.25rem', background: '#9f9f9f', borderColor: '#9f9f9f', minWidth: 'auto', width: 65, padding: 10 }}
                          onClick={() => {
                            navigator.clipboard.writeText(code)
                            toast.success('کپی شد', { autoClose: 700, theme: 'dark' })
                          }}>
                          <MdContentCopy />
                        </button>
                      </div>
                    ))

                  ))
                }




                {!isBUYER && <PriceRangeButton data={paidLinks} selcetedItem={filterLinks} user_id={auth.userId} />}

                <hr style={{ opacity: .1 }} />
                {filteredLinks(paidLinks)}

              </div>
            }



          </div>
        </div>
      </div>
    </>
  )


}
